import { useDebouncedValue } from '@openx/utils/hooks/useDebouncedValue.ts';
import { useFormContext, useWatch } from 'react-hook-form';
import { PREVIEW_DEBOUNCE_MS } from '../../components/preview/constants.ts';
import { VideoThumbnail as VideoThumbnailPreview } from '../../components/preview/VideoThumbnail.tsx';
import type { VideoCreativeFormData } from '../validation/videoCreative.ts';

export const VideoThumbnail = () => {
  const { control } = useFormContext<VideoCreativeFormData>();
  const observableMarkupPayload = useWatch({ control, name: 'markup_payload' });
  const debouncedMarkup = useDebouncedValue(observableMarkupPayload, PREVIEW_DEBOUNCE_MS);

  return <VideoThumbnailPreview markupPayload={debouncedMarkup} />;
};
